import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainPageComponent } from './main-page/main-page.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SharedModule } from '../shared/shared.module';
import { ActiveLinkDirective } from '../shared/active-link.directive';
import { HasPermissionDirective } from '../shared/has-permission.directive';
import { UiModule } from '../ui/ui.module';
import { AiChatDrawerComponent } from '../features/ai-chat/components/ai-chat-drawer/ai-chat-drawer.component';
import { NotificationsModule } from '../features/notifications/notifications.module';
import { SvgIconComponent } from "src/app/ui/svg-icon/svg-icon.component";

@NgModule({
  declarations: [
    MainPageComponent,
    SidebarComponent,
    NavbarComponent,
    ActiveLinkDirective
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
    HasPermissionDirective,
    AiChatDrawerComponent,
    NotificationsModule,
    SvgIconComponent
]
})
export class LayoutModule { }
